/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "loadedsounds",
	listeners: listeners,
});

function listeners() {
	return {
		// Add more variations on sound loading here
		"desktopsounds:updated": this.push
	};
}
